import type { RoleConfig } from '../types.js';

export const janitor: RoleConfig = {
  id: 'janitor',
  faction: 'mafia',
  title: { ru: 'Уборщик', uk: 'Прибиральник' },
  latin: 'JANITOR',
  number: '23',
  accent: '#5a6a4a',
  ability: {
    ru: 'Когда мафия убивает — роль жертвы остаётся скрытой утром.',
    uk: 'Коли мафія вбиває — роль жертви залишається прихованою вранці.',
  },
  abilities: [
    { key: 'kill', phase: 'night', cadence: 'every-night', canSelfTarget: false, killGroup: 'mafia' },
  ],
  cleansVictims: true,
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
